import Collection from '@/components/Collection'
import CreateForm from '@/pages/alpha/CreateForm'
import access from '../access'
import punycode from 'punycode';

export default {

  'alpha.collection': {
    path: '/admin/alphas',
    name: 'alpha.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listAlphaTLD",
      entity: "alpha",
      cols: [
        {
          label: "Alpha TLD",
          html: (tld) => {
            if (tld.indexOf('xn--') === 0) {
              return tld + ' <code>' + punycode.toUnicode(tld) + '</code>';
            } else {
              return tld;
            }
          }
        },
      ]
    },
    meta: {
      access: access.admin,
      title: "Alpha TLD list",
      side_menu: { label: "Alpha TLDs",  icon: "sphere" },
      local_actions: [
        { name: "alpha.create", label: "Create Alpha TLD", color: "success", icon: "plus" }
      ]
    },
  },

  'alpha.create': {
    path: '/admin/alphas/create',
    name: 'alpha.create',
    component: CreateForm,
    meta: {
      access: access.admin,
      title: "Create new Alpha TLD"
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/alpha.js